/**
 * organizations
 */
export const ORGANIZATIONS_LOAD_REQUESTED = 'ORGANIZATIONS_LOAD_REQUESTED';
export const ORGANIZATIONS_LOAD_SUCCEEDED = 'ORGANIZATIONS_LOAD_SUCCEEDED';
export const ORGANIZATIONS_LOAD_FAILED = 'ORGANIZATIONS_LOAD_FAILED';

export const NEW_ORGANIZATION_REQUESTED = 'NEW_ORGANIZATION_REQUESTED';
export const NEW_ORGANIZATION_SUCCEEDED = 'NEW_ORGANIZATION_SUCCEEDED';
export const NEW_ORGANIZATION_FAILED = 'NEW_ORGANIZATION_FAILED';
export const NEW_ORGANIZATION_NAMESPACE = 'NEW_ORGANIZATION';
